const data = /[^0-9a-zA-ZÀ-ÿ\u00f1\u00d1]/gi;

export default data;
